import { Tooltip } from "primereact/tooltip"

export const CellTooltip = ({ text = "", target = "cell-tooltip" }) => {
  const targetString = `.${target}`

  return (
    <>
      <Tooltip
        target={targetString}
        content={text}
        mouseTrack
        mouseTrackLeft={20}
      />
      <span className={`${target}`}>{text}</span>
    </>
  )
}
